function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import * as log from '../log';
import { isConcatSpec, isHConcatSpec, isVConcatSpec } from './concat';
import { isFacetSpec } from './facet';
import { isLayerSpec } from './layer';
import { isRepeatSpec } from './repeat';
import { isUnitSpec } from './unit';
export var SpecMapper = /*#__PURE__*/function () {
  function SpecMapper() {
    _classCallCheck(this, SpecMapper);
  }

  _createClass(SpecMapper, [{
    key: "map",
    value: function map(spec, params) {
      if (isFacetSpec(spec)) {
        return this.mapFacet(spec, params);
      } else if (isRepeatSpec(spec)) {
        return this.mapRepeat(spec, params);
      } else if (isHConcatSpec(spec)) {
        return this.mapHConcat(spec, params);
      } else if (isVConcatSpec(spec)) {
        return this.mapVConcat(spec, params);
      } else if (isConcatSpec(spec)) {
        return this.mapConcat(spec, params);
      } else {
        return this.mapLayerOrUnit(spec, params);
      }
    }
  }, {
    key: "mapLayerOrUnit",
    value: function mapLayerOrUnit(spec, params) {
      if (isLayerSpec(spec)) {
        return this.mapLayer(spec, params);
      } else if (isUnitSpec(spec)) {
        return this.mapUnit(spec, params);
      }

      throw new Error(log.message.invalidSpec(spec));
    }
  }, {
    key: "mapLayer",
    value: function mapLayer(spec, params) {
      var _this = this;

      return _objectSpread(_objectSpread({}, spec), {}, {
        layer: spec.layer.map(function (subspec) {
          return _this.mapLayerOrUnit(subspec, params);
        })
      });
    }
  }, {
    key: "mapHConcat",
    value: function mapHConcat(spec, params) {
      var _this2 = this;

      return _objectSpread(_objectSpread({}, spec), {}, {
        hconcat: spec.hconcat.map(function (subspec) {
          return _this2.map(subspec, params);
        })
      });
    }
  }, {
    key: "mapVConcat",
    value: function mapVConcat(spec, params) {
      var _this3 = this;

      return _objectSpread(_objectSpread({}, spec), {}, {
        vconcat: spec.vconcat.map(function (subspec) {
          return _this3.map(subspec, params);
        })
      });
    }
  }, {
    key: "mapConcat",
    value: function mapConcat(spec, params) {
      var _this4 = this;

      var concat = spec.concat,
          rest = _objectWithoutProperties(spec, ["concat"]);

      return _objectSpread(_objectSpread({}, rest), {}, {
        concat: concat.map(function (subspec) {
          return _this4.map(subspec, params);
        })
      });
    }
  }, {
    key: "mapFacet",
    value: function mapFacet(spec, params) {
      return _objectSpread(_objectSpread({}, spec), {}, {
        // TODO: remove "any" once we support all facet listed in https://github.com/vega/vega-lite/issues/2760
        spec: this.map(spec.spec, params)
      });
    }
  }, {
    key: "mapRepeat",
    value: function mapRepeat(spec, params) {
      return _objectSpread(_objectSpread({}, spec), {}, {
        // as any is required here since TS cannot infer that the output type satisfies the input type
        spec: this.map(spec.spec, params)
      });
    }
  }]);

  return SpecMapper;
}();